import styled from "@emotion/styled";

export const StyledInputContainer = styled("div")`
    flex: 1;
    // So the inner input can inherit from the outer component.
    border-radius: inherit;
`;
